import * as React from 'react';

function SvgArrowRight(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.733 8.002a.58.58 0 00-.455.412.595.595 0 00.162.597l5.343 5.387H5.556a.585.585 0 00.055 1.17h17.172l-5.343 5.387a.589.589 0 00.235 1.03c.217.05.444-.03.583-.205l6.342-6.375.4-.422-.4-.422-6.342-6.375a.58.58 0 00-.473-.184h-.052z"
        fill={props.color || '#414B56'}
      />
    </svg>
  );
}

export default SvgArrowRight;
